/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiEntityType } from './InternalApiEntityType';
import {
    InternalApiEntityTypeFromJSON,
    InternalApiEntityTypeFromJSONTyped,
    InternalApiEntityTypeToJSON,
    InternalApiEntityTypeToJSONTyped,
} from './InternalApiEntityType';
import type { InternalApiUserBasicDetails } from './InternalApiUserBasicDetails';
import {
    InternalApiUserBasicDetailsFromJSON,
    InternalApiUserBasicDetailsFromJSONTyped,
    InternalApiUserBasicDetailsToJSON,
    InternalApiUserBasicDetailsToJSONTyped,
} from './InternalApiUserBasicDetails';
import type { InternalApiScreeningFlow } from './InternalApiScreeningFlow';
import {
    InternalApiScreeningFlowFromJSON,
    InternalApiScreeningFlowFromJSONTyped,
    InternalApiScreeningFlowToJSON,
    InternalApiScreeningFlowToJSONTyped,
} from './InternalApiScreeningFlow';

/**
 * 
 * @export
 * @interface InternalApiScreeningFlowDraft
 */
export interface InternalApiScreeningFlowDraft {
    /**
     * 
     * @type {number}
     * @memberof InternalApiScreeningFlowDraft
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningFlowDraft
     */
    flowId: string;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScreeningFlowDraft
     */
    organisationId: number;
    /**
     * 
     * @type {InternalApiEntityType}
     * @memberof InternalApiScreeningFlowDraft
     */
    entityType: InternalApiEntityType;
    /**
     * 
     * @type {InternalApiScreeningFlow}
     * @memberof InternalApiScreeningFlowDraft
     */
    snapshot: InternalApiScreeningFlow;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningFlowDraft
     */
    note?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScreeningFlowDraft
     */
    activatedTime?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScreeningFlowDraft
     */
    testCount?: number;
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiScreeningFlowDraft
     */
    createdBy: InternalApiUserBasicDetails;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScreeningFlowDraft
     */
    createdTime: Date;
}



/**
 * Check if a given object implements the InternalApiScreeningFlowDraft interface.
 */
export function instanceOfInternalApiScreeningFlowDraft(value: object): value is InternalApiScreeningFlowDraft {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('flowId' in value) || value['flowId'] === undefined) return false;
    if (!('organisationId' in value) || value['organisationId'] === undefined) return false;
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('snapshot' in value) || value['snapshot'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    return true;
}

export function InternalApiScreeningFlowDraftFromJSON(json: any): InternalApiScreeningFlowDraft {
    return InternalApiScreeningFlowDraftFromJSONTyped(json, false);
}

export function InternalApiScreeningFlowDraftFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningFlowDraft {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'flowId': json['flowId'],
        'organisationId': json['organisationId'],
        'entityType': InternalApiEntityTypeFromJSON(json['entityType']),
        'snapshot': InternalApiScreeningFlowFromJSON(json['snapshot']),
        'note': json['note'] == null ? undefined : json['note'],
        'activatedTime': json['activatedTime'] == null ? undefined : (new Date(json['activatedTime'])),
        'testCount': json['testCount'] == null ? undefined : json['testCount'],
        'createdBy': InternalApiUserBasicDetailsFromJSON(json['createdBy']),
        'createdTime': (new Date(json['createdTime'])),
    };
}

export function InternalApiScreeningFlowDraftToJSON(json: any): InternalApiScreeningFlowDraft {
    return InternalApiScreeningFlowDraftToJSONTyped(json, false);
}

export function InternalApiScreeningFlowDraftToJSONTyped(value?: InternalApiScreeningFlowDraft | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'flowId': value['flowId'],
        'organisationId': value['organisationId'],
        'entityType': InternalApiEntityTypeToJSON(value['entityType']),
        'snapshot': InternalApiScreeningFlowToJSON(value['snapshot']),
        'note': value['note'],
        'activatedTime': value['activatedTime'] == null ? value['activatedTime'] : value['activatedTime'].toISOString(),
        'testCount': value['testCount'],
        'createdBy': InternalApiUserBasicDetailsToJSON(value['createdBy']),
        'createdTime': value['createdTime'].toISOString(),
    };
}

